import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=77c2e2cc&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77c2e2cc')) {
      api.createRecord('77c2e2cc', component.options)
    } else {
      api.reload('77c2e2cc', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=77c2e2cc&", function () {
      api.rerender('77c2e2cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2c2yJ42po6XX0/JS/offershelp.vue"
export default component.exports